export const isNotCovered = (value: unknown): boolean =>
  value === null ||
  value === undefined ||
  value === false ||
  value === "false" ||
  value === "None" ||
  value === "Not Covered" ||
  value === "0.0" ||
  value === "0" ||
  value === 0;
